<h2 mat-dialog-title>{{ popupTitle }}</h2>

<mat-dialog-content>
  <p>{{ popupDescription }}</p>
</mat-dialog-content>

<mat-dialog-actions class="idle__popup--buttons">
  <button mat-raised-button color="accent" (click)="okay()">Okay</button>
</mat-dialog-actions>
